<template>
  <div class="productList w-100">
    <BackgroundCircle class="backgroundCircle" />
    <div class="w-100 d-flex flex-column justify-content-center align-items-center">
      <div class="w-100 productList__btn d-flex justify-content-end mt-52">
        <button class="productList__btn--goBack" @click="goBack">
          <i class="el-icon-back mr-2"></i>
          回上一頁
        </button>
      </div>
      <h1 class="productList__title textColor">{{ title }}</h1>
      <p class="productList__description--contents">
        <vue-editor v-model="contents" :disabled="true"></vue-editor>
        <!-- {{ contents }} -->
      </p>
    </div>

    <div class="productList__content d-flex justify-content-center align-items-center">
      <div v-for="item in tabList" :key="item.id">
        <button
          class="productList__content--btn"
          :class="{ active: $route.query.routerName === item.routerName }"
          @click="changeTab(item)"
        >
          {{ item.name }}
        </button>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import BackgroundCircle from "@/components/BackgroundCircle";
export default {
  components: { BackgroundCircle },
  data() {
    return {
      year: "",
      title: this.$route.query.title,
      contents: this.$route.query.contents,
      optionsGroup: [],
      groupTypeId: "",
      tabList: [
        { id: 1, name: "設計組", routerName: "product", groupTypeId: "" },
        { id: 2, name: "創作組", routerName: "creation", groupTypeId: "" },
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.push({ name: "exhibitionList" });
    },
    changeTab(item) {
      this.$router.push({
        name: item.routerName,
        params: { id: this.$route.params.id },
        query: {
          year: this.year,
          routerName: item.routerName,
          groupTypeId: item.groupTypeId,
        },
      });
    },
    getGroupList() {
      this.$api.getGroupTypeList().then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.groupTypeId = data[0].dtCode;

          data.forEach((dataItem) => {
            this.tabList.forEach((item, index) => {
              if (dataItem.name === item.name) {
                this.tabList[index].groupTypeId = dataItem.dtCode;
              }
            });
          });
        }
      });
    },
    getUnitGraduateData() {
      this.$api.getUnitGraduate({ id: this.$route.params.id }).then((res) => {
        const { code, result } = res.data;
        if (code === 200) {
          this.year = result.annual;
          this.title = result.title;
          this.contents = result.contents;
        }
      });
    },
  },
  mounted() {
    this.getGroupList();
    this.getUnitGraduateData();
  },
};
</script>

<style lang="scss">
.productList {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  overflow: hidden;
  @media (min-width: 1024px) {
    margin-bottom: 120px;
  }

  .backgroundCircle {
    position: absolute;
    left: -10px;
  }

  &__btn {
    &--goBack {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      cursor: pointer;
      margin: 0 90px;
      font-size: 24px;
      line-height: 28px;
      letter-spacing: 0.005em;
      padding: 8px 12px;
      color: #e0d2af;
      background: #2d2d2d;
      border: 2px solid #e0d2af;
      box-sizing: border-box;
      border-radius: 25px;
      &:hover {
        color: #2d2d2d;
        background: #e0d2af;
        transition: 0.3s;
      }
      @media (max-width: 1024px) {
        font-size: 14px;
        line-height: 16px;
        margin-right: 28px;
      }
      .el-icon-back {
        font-size: 20px;
      }
    }
  }

  &__title {
    background: linear-gradient(180deg, #ceb87f 0%, #fff2d0 100%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    margin: 40px 0 0 0;
    font-size: 64px;
    line-height: 75px;
    @media (max-width: 1024px) {
      padding: 0 28px;
      font-size: 28px;
      line-height: 33px;
    }
  }
  &__description {
    position: relative;
    margin-top: 24px;
    padding: 0 400px 60px 400px;
    color: #fff;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    letter-spacing: 0.02em;
    @media (max-width: 1024px) {
      padding: 0 16px 60px 16px;
    }
    &::before {
      content: "";
      position: absolute;
      bottom: 0%;
      right: 50%;
      transform: translateX(50%);
      background: #ceb87f;
      width: 90%;
      height: 2px;
      @media (max-width: 1024px) {
        width: 90%;
      }
    }

    &--contents {
      padding: 0 30px;
      color: #ffffff;

      @media (min-width: 768) {
        padding: 0 90px;
      }
      .ql-editor {
        padding: 0;
        min-height: 50px;
      }
      .ql-toolbar {
        display: none !important;
      }
      .ql-container {
        border: none !important;
        ol {
          padding-left: 0;
        }
      }
    }
  }
  &__content {
    width: 100%;
    margin: 40px 0 24px;
    &--btn {
      cursor: pointer;
      margin: 0 12px;
      font-size: 24px;
      line-height: 28px;
      letter-spacing: 0.005em;
      padding: 8px 32px;
      color: #e0d2af;
      background: #2d2d2d;
      border: 2px solid #e0d2af;
      box-sizing: border-box;
      border-radius: 25px;
      &:hover {
        color: #2d2d2d;
        background: #e0d2af;
        transition: 0.3s;
      }
    }
    .active {
      color: #2d2d2d;
      background: #e0d2af;
    }
  }
}
</style>